import Model, { hasMany } from "@ember-data/model";
import type Store from "@ember-data/store";
import type ModelRegistry from "@ember-data/types/registries/model";
import { service } from "@ember/service";
export default class TherapeuticalArea extends Model {
  @service declare store: Store;

  @hasMany("adverse-event", { async: false, inverse: "therapeuticalAreas" })
  declare adverseEvents: Array<ModelRegistry["adverse-event"]>;
  @hasMany("default-bio-exam", { async: false, inverse: "therapeuticalAreas" })
  declare defaultBioExams: Array<ModelRegistry["default-bio-exam"]>;
  @hasMany("follow-up-reason", { async: false, inverse: "therapeuticalArea" })
  declare followUpReasons: Array<ModelRegistry["follow-up-reason"]>;
  @hasMany("image", { async: false, inverse: "therapeuticalAreas" })
  declare images: Array<ModelRegistry["image"]>;
  @hasMany("priority-bio-exam", { async: false, inverse: "therapeuticalAreas" })
  declare priorityBioExams: Array<ModelRegistry["priority-bio-exam"]>;

  get productDisplayName(): string {
    return this.id.charAt(0).toUpperCase() + this.id.slice(1) + "Wise";
  }
}

declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "therapeutical-area": TherapeuticalArea;
  }
}
